import { OfficeConsentContentAdapter } from '../adapters';
import { ConsentsClient } from '../clients';
import { OfficeConsentNotFoundError } from '../errors';
import type { IOfficeConsentContent } from '../types/OfficeConsentContent';
import type { IGetOfficeConsentContentParameters } from '../types/OfficeConsentContent.parameters';

export const getOfficeConsentContent = async (
  params: IGetOfficeConsentContentParameters,
): Promise<IOfficeConsentContent> => {
  try {
    const apiResponse = await ConsentsClient.getOfficeConsentContent(params);

    return OfficeConsentContentAdapter.toOfficeConsentContent(apiResponse);
  } catch (e) {
    const officeConsentNotFound = OfficeConsentNotFoundError.fromAxiosError(e);
    if (officeConsentNotFound) {
      throw officeConsentNotFound;
    }

    throw e;
  }
};
